import { useMemo } from "react";

import { useBookingById } from "../../../../api/hooks/useBookingById/useBookingById.ts";
import { useBooking } from "../../../../utils/context/Booking/BookingContext.tsx";
import {
  mapBookingToEquipmentForm,
  mapBookingToInfoForm,
} from "../../../../utils/context/Booking/mapBookingResponse.ts";
import { isEqual } from "../../../../utils/isEqual.ts";

export const useIsBookingDataChanged = () => {
  const { booking, equipment } = useBooking();
  const { data } = useBookingById();

  // Must use the same mapping Booking.tsx loads into the context, or an untouched booking never
  // compares equal.
  const initialBookingData = useMemo(() => (data ? mapBookingToInfoForm(data) : null), [data]);
  const initialEquipmentData = useMemo(
    () => (data ? mapBookingToEquipmentForm(data) : null),
    [data],
  );

  return {
    isBookingDataChanged: !(
      isEqual(booking, initialBookingData) && isEqual(equipment, initialEquipmentData)
    ),
  };
};
